// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { avatarType, avatarShape, avatarSize, avatarFill, avatarThemeColor } from './interfaces/Enums';
import { packageMetadata } from '../package-metadata';
import { getDefaultSlots, validatePackage } from '@progress/kendo-vue-common';
/**
 * Represents the default `Avatar` component.
 */

var Avatar = {
  name: 'KendoAvatar',
  props: {
    shape: {
      type: String,
      default: avatarShape.SQUARE,
      validator: function validator(value) {
        return ['circle', 'square', 'rounded', 'rectangle'].includes(value);
      }
    },
    type: {
      type: String,
      default: avatarType.TEXT,
      validator: function validator(value) {
        return ['text', 'image', 'icon'].includes(value);
      }
    },
    fill: {
      type: String,
      default: avatarFill.SOLID,
      validator: function validator(value) {
        return ['solid', 'outline'].includes(value);
      }
    },
    size: {
      type: String,
      default: avatarSize.MEDIUM,
      validator: function validator(value) {
        return ['small', 'medium', 'large'].includes(value);
      }
    },
    themeColor: {
      type: String,
      default: avatarThemeColor.PRIMARY,
      validator: function validator(value) {
        return ['primary', 'secondary', 'tertiary', 'info', 'success', 'warning', 'error', 'dark', 'light', 'inverse', 'inherit'].includes(value);
      }
    }
  },
  created: function created() {
    validatePackage(packageMetadata);
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  computed: {
    wrapperClass: function wrapperClass() {
      var _a;

      return _a = {
        'k-avatar': true
      }, _a["k-avatar-" + this.$props.fill] = true, _a["k-avatar-" + this.$props.shape] = true, _a["k-avatar-" + this.$props.themeColor] = true, _a['k-avatar-bordered'] = this.$props.border, _a['k-avatar-sm'] = this.$props.size === 'small', _a['k-avatar-md'] = this.$props.size === 'medium', _a['k-avatar-lg'] = this.$props.size === 'large', _a;
    }
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlots = getDefaultSlots(this);
    return h("div", {
      "class": this.wrapperClass
    }, [h("span", {
      "class": "k-avatar-" + this.$props.type
    }, [defaultSlots])]);
  }
};
var AvatarVue3 = Avatar;
export { Avatar, AvatarVue3 };